export enum Roles {
    Owner = 'frontol_owner',
    Manager = 'frontol_manager',
    Administrator = 'frontol_it_admin',
}

export const rolesList = [Roles.Owner, Roles.Manager, Roles.Administrator] as const
